import { useCallback } from "react";
import { useRouter } from "next/router";

type BottomButton = {
	text: string;
	link?: string;
	onClick?: () => void;
};

/**
 * Hook to handle bottom button click and navigation
 */
export function useBottomButton(bottomButton?: BottomButton): () => void {
	const router = useRouter();

	const redirectOnBottomButtonClick = useCallback(() => {
		if (!bottomButton) return;
		if (bottomButton.onClick) {
			bottomButton.onClick();
		} else if (bottomButton.link) {
			router.push(bottomButton.link);
		}
	}, [bottomButton, router]);

	return redirectOnBottomButtonClick;
}
